<div class="modal fade show custom_popup" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl" role="document">
    <div class="modal-content">
      <div class="modal-header justify-content-between">
        <h5 class="modal-title">Add New User</h5>
        <button type="button" class="close" data-dismiss="modal" (click)="closeModal()">
          <span>&times;</span>
        </button>
      </div>
      <div class="modal-body padding-model form-editing">
        <div class="row">
          <div class="col-lg-12">
            <div class="card w-110">
              <div class="card">
                <form *ngIf="userForm" [formGroup]="userForm">
                  <div class="row">
                    <div class="field-groups width-110">
                      <div class="mt-3">
                        <label for="firstName" class="form-title"><span class="required">*</span> First Name</label>
                        <input
                          type="text"
                          class="form-control sd-width"
                          placeholder=""
                          formControlName="firstName"
                          id="firstName"
                        />
                      </div>
                      <app-form-error-component [control]="userForm.controls['firstName']" />
                    </div>

                    <div class="field-groups width-110">
                      <div class="mt-3">
                        <label for="lastName" class="form-title"><span class="required">*</span> Last Name</label>
                        <input
                          type="text"
                          class="form-control sd-width"
                          placeholder=""
                          formControlName="lastName"
                          id="lastName"
                        />
                      </div>
                      <app-form-error-component [control]="userForm.controls['lastName']" />
                    </div>

                    <div class="field-groups col">
                      <div class="mt-3">
                        <label for="email" class="form-title">
                          <span class="required">*</span> Password
                          <button
                            class="generate-password-btn pb-0 pt-0 btn btn-icon"
                            tooltip="Generate Password"
                            (click)="generatePassword()"
                          >
                            <i class="bi bi-lock-fill"></i>
                          </button>
                        </label>
                        <input
                          type="text"
                          class="form-control sd-width"
                          placeholder=""
                          formControlName="password"
                          id="password"
                        />
                      </div>
                      <ng-container *ngIf="passwordCtrl.touched">
                        <app-form-error-component [control]="userForm.controls['password']" />
                      </ng-container>
                    </div>
                  </div>

                  <div class="row">
                    <div class="phone-container width-177 field-groups">
                      <div class="mt-3">
                        <label for="phoneNumber" class="form-title text-nowrap">
                          <span class="required">*</span> Phone Number
                          <span class="tooltip-ng ms-0" placement="bottom" ngbTooltip="Phone Number">
                            <i class="bi bi-question-circle"></i>
                          </span>
                        </label>

                        <ng-container formGroupName="phone">
                          <div class="d-flex flex-column">
                            <div class="d-flex align-items-center">
                              <input
                                type="text"
                                class="form-control width-45 me-1"
                                appOnlyNumber
                                maxlength="4"
                                formControlName="phoneCountryCode"
                              />
                              <input
                                type="text"
                                class="form-control width-35 me-1"
                                appOnlyNumber
                                maxlength="3"
                                formControlName="phoneAreaCode"
                              />
                              <input
                                type="text"
                                class="form-control width-80"
                                appOnlyNumber
                                formControlName="phoneNumber"
                              />
                            </div>
                          </div>
                          <label
                            *ngIf="phoneGroup.errors?.['phoneFieldsIncomplete']"
                            for=""
                            class="error text-nowrap mt-0"
                          >
                            <img alt="" src="assets/images/icon/error.png" class="error-icon" />
                            Please enter all phone number fields
                          </label>
                        </ng-container>
                      </div>
                    </div>

                    <div class="field-groups col">
                      <div class="mt-3">
                        <label for="email" class="form-title"><span class="required">*</span> Email</label>
                        <input
                          type="text"
                          class="form-control sd-width"
                          placeholder=""
                          formControlName="email"
                          id="email"
                        />
                      </div>
                      <app-form-error-component [control]="userForm.controls['email']" />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-12 bottom-fixed">
                      <hr />
                      <div class="d-flex justify-content-center mt-3">
                        <button
                          [disabled]="userForm.invalid || (isLoading$ | async)"
                          type="submit"
                          class="btn btn-light me-3 btn-custom-footer save_btn"
                          (click)="onSubmit()"
                        >
                          Save
                        </button>
                        <button
                          type="button"
                          class="btn btn-light btn-custom-footer cancel_btn"
                          data-dismiss="modal"
                          (click)="closeModal()"
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
